'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Inspirations = require('./Inspirations.scss');

var _Inspirations2 = _interopRequireDefault(_Inspirations);

var _reactIntl = require('react-intl');

var _Breadcrumbs = require('components/Breadcrumbs/Breadcrumbs');

var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);

var _media = require('utils/media');

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _inspirations = require('redux/modules/inspirations');

var InspirationsAction = _interopRequireWildcard(_inspirations);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Inspirations: {
    displayName: 'Inspirations'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/containers/Inspirations/Inspirations.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

// import InspirationCard from 'components/Inspirations/InspirationCard';


var Inspirations = _wrapComponent('Inspirations')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    if (!(0, _inspirations.isLoaded)(getState())) {
      return dispatch((0, _inspirations.load)());
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    inspirations: state.inspirations.data,
    error: state.inspirations.error,
    loading: state.inspirations.loading
  };
}, InspirationsAction), _dec3 = (0, _reactCssModules2.default)(_Inspirations2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Inspirations, _Component);

  function Inspirations() {
    (0, _classCallCheck3.default)(this, Inspirations);
    return (0, _possibleConstructorReturn3.default)(this, (Inspirations.__proto__ || (0, _getPrototypeOf2.default)(Inspirations)).apply(this, arguments));
  }

  (0, _createClass3.default)(Inspirations, [{
    key: 'render',
    value: function render() {
      var bannerImage = require('./inspiration.jpg');
      return _react3.default.createElement(
        'div',
        { styleName: 'main-container' },
        _react3.default.createElement(_reactHelmet2.default, {
          meta: [{ 'property': 'og:image', 'content': 'https://www.takemetour.com' + bannerImage }]
        }),
        _react3.default.createElement(
          'div',
          { styleName: 'inspiration-banner' },
          _react3.default.createElement(
            'div',
            { styleName: 'banner-shadow' },
            _react3.default.createElement(
              'h1',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'inspirations.banner.header' })
            ),
            _react3.default.createElement(
              'h3',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'inspirations.banner.sub_header' })
            )
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'inner' },
          _react3.default.createElement(_Breadcrumbs2.default, { type: 'Inspirations', customStyle: { paddingTop: '0px', paddingLeft: '10px' } }),
          _react3.default.createElement(
            'h2',
            { styleName: 'header' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'inspirations.content.header' })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'inspirations-container' },
            this.props.inspirations.map(function (insp) {
              if (insp.is_public) {
                return _react3.default.createElement(
                  _Link2.default,
                  { key: insp._id, styleName: 'inspiration-card', to: '/inspiration/' + insp.slug },
                  _react3.default.createElement(
                    'div',
                    { styleName: 'card-image' },
                    _react3.default.createElement('img', { src: (0, _media.path)(insp.thumbnail_image, 'coverTripCard'), styleName: 'card-image-img', alt: insp.name }),
                    _react3.default.createElement(
                      'div',
                      { styleName: 'card-shadow' },
                      _react3.default.createElement(
                        'h2',
                        null,
                        insp.name
                      )
                    )
                  ),
                  _react3.default.createElement(
                    'div',
                    { styleName: 'card-detail' },
                    _react3.default.createElement(
                      'h3',
                      { styleName: 'inspiration-name' },
                      insp.name
                    ),
                    _react3.default.createElement(
                      'p',
                      { styleName: 'inspiration-description' },
                      insp.description
                    )
                  ),
                  _react3.default.createElement(
                    'div',
                    { styleName: 'see-more-container' },
                    _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'inspirations.content.item.see_more' })
                  )
                );
              }
            })
          )
        )
      );
    }
  }]);
  return Inspirations;
}(_react2.Component), _class2.propTypes = {
  inspirations: _react2.PropTypes.array,
  error: _react2.PropTypes.string,
  loading: _react2.PropTypes.bool,
  load: _react2.PropTypes.func.isRequired
}, _temp)) || _class) || _class) || _class));

exports.default = Inspirations;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Inspirations/Inspirations.js
// module id = 1675
// module chunks = 38